import {
    calendarDateInZone,
    type CalendarDate,
    type IanaTimeZone,
    shiftCalendarDate,
    zonedDayBounds,
} from '@baby-tracker/validation';

export { shiftCalendarDate };

/** Half-open UTC window covering the last `days` calendar days in `timeZone`, including today. */
export function recentWindow(
    timeZone: IanaTimeZone,
    days: number,
): { from: string; to: string; today: CalendarDate } {
    const today = calendarDateInZone(new Date(), timeZone);
    const start = shiftCalendarDate(today, 1 - days);
    return {
        from: zonedDayBounds(start, timeZone).from,
        to: zonedDayBounds(today, timeZone).to,
        today,
    };
}

/** Night when the local hour is 7pm–6am; otherwise a nap. The saved value is whatever the user picks. */
export function suggestedSleepKind(timeZone: IanaTimeZone): 'nap' | 'night' {
    const hour = Number(
        new Intl.DateTimeFormat('en-GB', { timeZone, hour: 'numeric', hourCycle: 'h23' }).format(
            new Date(),
        ),
    );
    return hour >= 19 || hour < 6 ? 'night' : 'nap';
}
